(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 767px)';
  var headerWords = /\b(size|bust|chest|waist|hip|forearm|arm|length|sleeve|shoulder|hem|neckline|au\s*size|fit)\b/i;

  function cleanText(value) {
    return String(value || '')
      .replace(/\u00a0/g, ' ')
      .replace(/[ \t]+/g, ' ')
      .trim();
  }

  function linesFromElement(element) {
    var clone = element.cloneNode(true);
    Array.prototype.forEach.call(clone.querySelectorAll('br'), function (br) {
      br.replaceWith('\n');
    });
    return String(clone.textContent || '')
      .split(/\n+/)
      .map(cleanText)
      .filter(Boolean);
  }

  function splitPipeLine(line) {
    return String(line || '')
      .split('|')
      .map(cleanText)
      .filter(function (cell) { return cell.length > 0; });
  }

  function isPipeLine(line) {
    return splitPipeLine(line).length >= 2;
  }

  function looksLikeHeader(line) {
    var cells = splitPipeLine(line);
    return cells.length >= 2 && headerWords.test(cells.join(' '));
  }

  function buildMeasurementTable(lines) {
    if (!lines || lines.length < 2 || !looksLikeHeader(lines[0])) return null;

    var headers = splitPipeLine(lines[0]);
    if (headers.length < 2) return null;

    var wrapper = document.createElement('div');
    wrapper.className = 'mn-product-measure-table-wrap';

    var table = document.createElement('table');
    table.className = 'mn-product-measure-table mn-mobile-responsive-table';

    var thead = document.createElement('thead');
    var headRow = document.createElement('tr');
    headers.forEach(function (header) {
      var th = document.createElement('th');
      th.scope = 'col';
      th.textContent = header;
      headRow.appendChild(th);
    });
    thead.appendChild(headRow);
    table.appendChild(thead);

    var tbody = document.createElement('tbody');
    lines.slice(1).forEach(function (line) {
      var values = splitPipeLine(line);
      if (values.length < 2) return;

      var row = document.createElement('tr');
      headers.forEach(function (header, index) {
        var cell = index === 0 ? document.createElement('th') : document.createElement('td');
        if (index === 0) cell.scope = 'row';
        cell.setAttribute('data-label', header);
        cell.textContent = values[index] || '—';
        row.appendChild(cell);
      });
      tbody.appendChild(row);
    });

    if (!tbody.children.length) return null;
    table.appendChild(tbody);
    wrapper.appendChild(table);
    return wrapper;
  }

  function replaceMultiLinePipeBlocks(root) {
    Array.prototype.slice.call(root.children).forEach(function (element) {
      if (element.matches('table, .mn-product-measure-table-wrap, ul, ol')) return;
      if (element.querySelector('table, .mn-product-measure-table-wrap')) return;

      var lines = linesFromElement(element);
      if (lines.length < 2) return;

      var firstPipe = lines.findIndex(isPipeLine);
      if (firstPipe < 0) return;

      var pipeLines = [];
      var endPipe = firstPipe;
      while (endPipe < lines.length && isPipeLine(lines[endPipe])) {
        pipeLines.push(lines[endPipe]);
        endPipe += 1;
      }

      var table = buildMeasurementTable(pipeLines);
      if (!table) return;

      var fragment = document.createDocumentFragment();
      lines.slice(0, firstPipe).forEach(function (line) {
        var note = document.createElement('p');
        note.className = 'mn-product-size-note';
        note.textContent = line;
        fragment.appendChild(note);
      });
      fragment.appendChild(table);
      lines.slice(endPipe).forEach(function (line) {
        var note = document.createElement('p');
        note.className = 'mn-product-size-note';
        note.textContent = line;
        fragment.appendChild(note);
      });

      element.replaceWith(fragment);
    });
  }

  function replaceConsecutivePipeBlocks(root) {
    var children = Array.prototype.slice.call(root.children);
    var index = 0;

    while (index < children.length) {
      var element = children[index];
      if (!element || element.parentNode !== root || element.matches('table, .mn-product-measure-table-wrap, ul, ol')) {
        index += 1;
        continue;
      }

      var lines = linesFromElement(element);
      if (lines.length !== 1 || !isPipeLine(lines[0]) || !looksLikeHeader(lines[0])) {
        index += 1;
        continue;
      }

      var groupElements = [element];
      var groupLines = [lines[0]];
      var nextIndex = index + 1;

      while (nextIndex < children.length) {
        var next = children[nextIndex];
        if (!next || next.parentNode !== root) break;
        var nextLines = linesFromElement(next);
        if (nextLines.length !== 1 || !isPipeLine(nextLines[0])) break;
        groupElements.push(next);
        groupLines.push(nextLines[0]);
        nextIndex += 1;
      }

      var table = buildMeasurementTable(groupLines);
      if (table && groupElements.length >= 2) {
        groupElements[0].replaceWith(table);
        groupElements.slice(1).forEach(function (node) { node.remove(); });
      }
      index = nextIndex;
    }
  }

  function rowIsMeasurementHeader(values) {
    if (!values || values.length < 2) return false;

    var matchingCells = values.filter(function (value) {
      return headerWords.test(cleanText(value));
    }).length;

    return matchingCells >= Math.max(2, Math.ceil(values.length * 0.6));
  }

  function labelTable(table) {
    if (!table || table.dataset.mnMobileLabels === 'true') return;

    var headers = Array.prototype.map.call(table.querySelectorAll('thead th'), function (th) {
      return cleanText(th.textContent);
    });
    var inferredHeaderRow = null;

    if (!headers.length) {
      var firstRow = table.querySelector('tr');
      if (firstRow) {
        var inferredHeaders = Array.prototype.map.call(firstRow.children, function (cell) {
          return cleanText(cell.textContent);
        });

        if (rowIsMeasurementHeader(inferredHeaders)) {
          headers = inferredHeaders;
          inferredHeaderRow = firstRow;
        }
      }
    }

    if (!headers.length) return;

    Array.prototype.forEach.call(table.querySelectorAll('tbody tr'), function (row) {
      if (row === inferredHeaderRow) return;

      Array.prototype.forEach.call(row.children, function (cell, cellIndex) {
        cell.setAttribute('data-label', headers[cellIndex] || ('Value ' + (cellIndex + 1)));
      });
    });

    if (inferredHeaderRow && inferredHeaderRow.parentNode) {
      inferredHeaderRow.remove();
    }

    table.classList.add('mn-mobile-responsive-table');
    table.dataset.mnMobileLabels = 'true';
  }

  function prepareProductDescriptions() {
    Array.prototype.forEach.call(document.querySelectorAll('.template-product .text-rich-text.product'), function (root) {
      if (root.dataset.mnMobileSizingPrepared === 'true') return;
      root.dataset.mnMobileSizingPrepared = 'true';

      replaceMultiLinePipeBlocks(root);
      replaceConsecutivePipeBlocks(root);

      Array.prototype.forEach.call(root.querySelectorAll('table'), labelTable);
    });
  }

  function prepareSizeGuide() {
    Array.prototype.forEach.call(document.querySelectorAll('.mn-sizecare-page .mn-sizecare-table'), labelTable);
  }

  function init() {
    if (!window.matchMedia(MOBILE_QUERY).matches) return;
    prepareProductDescriptions();
    prepareSizeGuide();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
